import { Component, Input, OnDestroy, OnInit, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';

import { Subscription } from 'rxjs/Subscription';

import { DataByProgram, DynReportService, ReportPeriod, Report11AP, ReportFilter, GroupCode } from '../shared';

import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';
import { TreeNode, Message, SelectItem } from "primeng/primeng";

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'bp-dyn-report',
  templateUrl: './dyn-report11AP.component.html',
  styleUrls: ['./dyn-report11AP.component.css'],
  providers: []
})

export class DynReport11APComponent implements OnDestroy, OnInit, AfterViewInit {

  @Input() reportName: string;
  private dbResetSubscription: Subscription;
  private id: any;

  @ViewChildren('scroll') scroll: QueryList<any>;

  selectedRow: TreeNode;
  filter: ReportFilter;
  infos: Message[];
  report: Report11AP;
  selectedYear: SelectItem;
  periodss: ReportPeriod[];
  selectedPeriod: ReportPeriod;
  groups: GroupCode[];
  selectedGroup: GroupCode = { value: "", text: "-" };

  budgetExeGraphData: any;
  budgetStructGraphData: any;
  top5expendituresGraphData: any;

  constructor(
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private reportService: DynReportService,
    private toastService: ToastService) {
  }

  private getReport(id: number, selectedGroup: string) {
    this.reportService.getReport11Ap(id, selectedGroup)
      .subscribe(report => {
        this.report = report;
        this.report.ttData = this.reportService.buildTableData11Ap(this.report.data);
        this.budgetExeGraphData = this.reportService.buildBudgetExeGraphData11Ap(this.report.data);
        this.budgetStructGraphData = this.reportService.buildBudgetStructGraphData11Ap(this.report.data);
        this.top5expendituresGraphData = this.reportService.buildTop5expendituresGraphData11ap(this.report.topExpenditures);
      });
  }

  private getYears() {
    this.reportService.getReport11ApYears()
      .subscribe(filter => {
        this.filter = filter;
      });
  }

  private getPeriods() {
    this.reportService.getReport11ApPeriods(this.selectedYear.value)
      .subscribe(filter => {
        if (this.filter) {
          this.filter.periods = filter.periods;
        } else {
          this.filter = filter;
        }
      });
  }


  private gotoReports() {
    this.router.navigate(['/reports']);
  }

  private handleServiceError(op: string, err: any) {
    console.error(`${op} error: ${err.message || err}`);
  }

  ngOnInit() {
    //this.getPeriods();
    this.getYears();
  }

  ngOnDestroy() {
    // this.dbResetSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.scroll.changes.subscribe((ellist: QueryList<any>) => {
      if (ellist.length > 0) {
        ellist.forEach((e, idx) => {
          if (!e.nativeElement['mcs']) {
            $(e.nativeElement).mCustomScrollbar("destroy");

            $(e.nativeElement).mCustomScrollbar({
              axis: "x",
              advanced: {
                updateOnContentResize: true
              },
              theme: "dark-thin",
              scrollButtons: {
                enable: true
              },
            });
          }
        });
      }

    });
  }

  showReport(event: Event) {
    this.getReport(this.selectedPeriod.id, this.selectedGroup.value);
  }

  nodeSelect(event) {
    //console.log('event', event);
    //this.infos = [];
    //this.infos.push({ severity: 'info', summary: 'Node Selected', detail: event.node.data.name });
    if (event.node && event.node.children && event.node.children.length > 0) {
      if (event.node.expanded == false)
        event.node.expanded = true;
      else
        event.node.expanded = false;
    }
  }

  nodeUnselect(event) {
    //this.infos = [];
    //this.infos.push({ severity: 'info', summary: 'Node Unselected', detail: event.node.data.name });
    if (event.node && event.node.children && event.node.children.length > 0) {
      event.node.expanded = false;
    }
  }

  periodChanged(event: Event) {
    this.selectedGroup = { value: "", text: '-' };
    this.groups = this.selectedPeriod.groups;
  }

  reportYearChanged(event: Event) {
    this.selectedGroup = { value: "", text: '-' };
    this.selectedPeriod = null;
    this.getPeriods();

  }
}



// WEBPACK FOOTER //
// ./src/app/dyn-reports/dyn-report/dyn-report11AP.component.ts